<div class="search-filter-container">
  <div class="search-input-wrapper">
    <ion-icon name="search-outline" class="search-icon" />
    <input
      #searchInput
      class="search-input"
      [placeholder]="placeholder | translate"
      [(ngModel)]="search"
      (input)="searchChange.emit(search)"
      type="text"
    />
    @if ((search || '').trim().length > 0) {
    <ion-icon
      name="close-circle"
      class="clear-icon"
      (click)="clearSearch(); $event.stopPropagation()"
    />
    }
  </div>
</div>
